// Extracted from FeaturedMarketSlide so that FeaturedSideRail (and anything else
// that only needs the price helper) does not have to import the slide, which
// pulls in recharts. The slide is otherwise only reachable through
// FeaturedMarketSlideDynamic, keeping charts out of the initial bundle.

const parseMaybe = (v: unknown): unknown => {
  if (typeof v === 'string') {
    try {
      return JSON.parse(v);
    } catch {
      return null;
    }
  }
  return v;
};

export const getYesPrice = (m: any): number => {
  if (!m) return 0;
  const prices = parseMaybe(m.outcomePrices);
  if (Array.isArray(prices) && prices.length) {
    const p = Number(prices[0]);
    if (Number.isFinite(p) && p > 0) return p;
  }
  const outs = parseMaybe(m.outcomes);
  if (Array.isArray(outs) && outs.length && typeof outs[0] === 'object' && outs[0]) {
    const p = Number((outs[0] as any).price ?? (outs[0] as any).midpoint);
    if (Number.isFinite(p) && p > 0) return p;
  }
  const bb = Number(m.bestBid ?? m.lastTradePrice);
  return Number.isFinite(bb) ? bb : 0;
};
